import { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { Z_INDICES, useModalState } from '@cmctechnology/webinvest-design-system';
import { MODAL_NAME, POST_MESSAGE, getConfig } from '@cmctechnology/webinvest-store-frontend';
import { FGFlowChangePassword, FGFlowChangeUsername, FGFlowDisableMfa, FGFlowEnableMfa } from '../Modules';
import { TRADING_IFRAME_ID } from '../Routes';
import { EventType, useAnalyticsContext } from '@cmctechnology/webinvest-analytics';

const getModalByName = (name: string, props: any) => {
  switch (name) {
    case MODAL_NAME.CHANGE_PASSWORD: {
      return <FGFlowChangePassword {...props} />;
    }
    case MODAL_NAME.CHANGE_USERNAME: {
      return <FGFlowChangeUsername {...props} />;
    }
    case MODAL_NAME.ENABLE_MFA:
    case MODAL_NAME.ADD_NEW_MFA_METHOD: {
      return <FGFlowEnableMfa {...props} />;
    }
    case MODAL_NAME.DISABLE_MFA: {
      return <FGFlowDisableMfa {...props} />;
    }
  }
  return (
    <>
      <Trans>MODAL_NAME is unknown!</Trans>
    </>
  );
};

const postToTradingAttempt = (name: string) => {
  const tradingRoot = document.querySelector(`#${TRADING_IFRAME_ID}`) as HTMLIFrameElement;
  if (name === MODAL_NAME.ENABLE_MFA || name === MODAL_NAME.DISABLE_MFA) {
    tradingRoot?.contentWindow?.postMessage(
      {
        type: POST_MESSAGE.UPDATE_MFA_STATUS
      },
      getConfig().stockbrokingUrl
    );
    tradingRoot?.contentWindow?.postMessage(
      {
        type: POST_MESSAGE.RELOAD_PAGE
      },
      getConfig().stockbrokingUrl
    );
  } else if (name === MODAL_NAME.CHANGE_USERNAME) {
    tradingRoot?.contentWindow?.postMessage(
      {
        type: POST_MESSAGE.RELOAD_PAGE
      },
      getConfig().stockbrokingUrl
    );
  }
};

export const PostMessageManager: React.FC = () => {
  const [, setModalState] = useModalState();
  const { trackEvent } = useAnalyticsContext();

  useEffect(() => {
    const messageHandler = (event: MessageEvent) => {
      if (event.data.type === POST_MESSAGE.SHOW_MODAL) {
        if (event.data.forced) {
          setModalState({
            dialog: getModalByName(event.data.name, {
              onNext: () => {
                setModalState({ open: false });
                postToTradingAttempt(event.data.name);
              }
            }),
            open: true,
            zIndex: Z_INDICES.TOP_OVERLAY,
            disableBackdropClick: true
          });
        } else {
          setModalState({
            dialog: getModalByName(event.data.name, {
              onNext: () => {
                setModalState({ open: false });
                postToTradingAttempt(event.data.name);
              },
              onCloseModal: () => {
                setModalState({ open: false });
              }
            }),
            open: true,
            zIndex: Z_INDICES.TOP_OVERLAY
          });
        }
      }
      if (event.data === 'TIPRANKS_NEWS_CLICK') {
        trackEvent('InPlatform', EventType.Navigation, {
          eventCategory: 'tabstrip tabstrip-block',
          eventAction: 'Click',
          eventLabel: 'TipRankNews', //text clicked
          pageUrl: window.location.href, //current page url document.location.href
          clickUrl: '/clients/tipranksnews.aspx' // Target URL of the clicked link
        });
      }
      if (event.data === 'TIPRANKS_STOCK_CLICK') {
        const params = new URLSearchParams(window.location.search);
        const asxcode = params.get('asxcode');

        trackEvent('InPlatform', EventType.Navigation, {
          eventCategory: 'tabstrip tabstrip-block',
          eventAction: 'Click',
          eventLabel: 'TipRank', //text clicked
          pageUrl: window.location.href, //current page url document.location.href
          clickUrl: `/Market/TipRanks.aspx?asxcode=${asxcode}`
        });
      }
    };

    window.addEventListener(`message`, messageHandler);

    return () => {
      window.removeEventListener(`message`, messageHandler);
    };
  }, []);

  return <></>;
};
